<template>
  <div class="v6-card">
    <!-- Header -->
    <div class="v6-header">
      <div class="v6-header-top">
        <h3 class="v6-title">{{statSubtitle}}</h3>
        <select v-if="filter" :name="action" @change="ChangeDatetop($event)" v-model="timeserchtype" class="v6-select">
          <option value="today">Today</option>
          <option value="thismonth">This Month</option>
          <option value="lastmonth">Last Month</option>
          <option value="thisyear">This Year</option>
          <option value="betweendate">Between date</option>
        </select>
      </div>

      <!-- Filters -->
      <div v-if="filterseller && currentUser && currentUser.type && currentUser.role && currentUser.role.name && currentUser.role.name!='Seller' && currentUser.type!='Seller'" class="v6-filters">
        <div class="v6-filter-row">
          <div class="v6-filter-item">
            <v-select @search="getUsersDebance($event,'shipsen')" @input="CheckSellerProducts($event,action,'seller')" label="fullName" placeholder="Seller" :options="sellers" v-model="sellerdata" class="v6-filter-select"></v-select>
          </div>
          <button class="v6-filter-clear" @click="removedata(action)">
            <i class="material-icons" style="font-size:16px">close</i>
          </button>
        </div>
      </div>

      <div v-if="filter && timeserchtype=='betweendate'" class="v6-filter-date">
        <date-picker placeholder="Range date ..." format="YYYY-MM-DD" type="date" class="v6-datepicker" v-model="fromDate" range></date-picker>
        <button @click="FindRecordsBetweenDate()" :class="!fromDate?'noselect':''" :disabled="!fromDate" class="v6-filter-search">
          <i class="material-icons" style="font-size:18px">search</i>
        </button>
      </div>
    </div>

    <!-- Ranked List (for topproducts & topsellersorders) -->
    <div v-if="action=='topproducts' || action=='topsellersorders'" class="v6-body">
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
      <div v-if="rankedItems.length > 0" class="v6-ranked-list">
        <div v-for="(item, index) in visibleItems" :key="index" class="v6-rank-item">
          <div class="v6-rank-badge" :class="'v6-rank-' + (index < 3 ? index + 1 : 'default')">{{ index + 1 }}</div>
          <div class="v6-rank-info">
            <span class="v6-rank-name">{{ item.name }}</span>
            <div class="v6-rank-bar-wrap">
              <div class="v6-rank-bar" :style="'width:' + item.percent + '%; background:' + item.barColor"></div>
            </div>
          </div>
          <div class="v6-rank-qty">
            <span class="v6-rank-qty-val">{{ item.y }}</span>
            <span class="v6-rank-qty-label">{{ action=='topsellersorders' ? 'orders' : 'qty' }}</span>
          </div>
        </div>
        <button v-if="rankedItems.length > (action === 'topsellersorders' ? 10 : 8)" @click="showAll = !showAll" class="v6-show-more">
          <i class="material-icons" style="font-size:16px;margin-right:4px">{{ showAll ? 'expand_less' : 'expand_more' }}</i>
          {{ showAll ? 'Show less' : 'Show more (' + (rankedItems.length - (action === 'topsellersorders' ? 10 : 8)) + ')' }}
        </button>
      </div>
      <div v-else class="v6-empty">No data available</div>
    </div>

    <!-- Chart (for topsellersorders) -->
    <div v-else class="v6-body">
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
      <div>
        <highcharts :options="chartOptions"></highcharts>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "card-stats-v6",
  props: {
   loading:{required:false},
   statSubtitle: {default: "Traffic",},
   filter: {default: false,},
   sellers:{type:Array},
   id:{type:String},
   from:{},
   to:{},
   dataChart:{type:Array,default:[]},
   label:{type:String},
   timeserch:{},
   currency: {default:"xof"},
   action: {},
   seller:{},
   currentUser:{type:Object},
   filterseller: {
      default: false,
    },
  },
  computed: {
    rankedItems() {
      if (!this.dataChart || !this.dataChart.length) return [];
      const colors = ['#4285f4', '#36b37e', '#ffab00', '#ff5630', '#6554c0', '#00b8d9', '#ff8b00', '#8777d9'];
      let items = [];
      for (const series of this.dataChart) {
        if (series.data) {
          for (const d of series.data) {
            if (Array.isArray(d)) {
              items.push({ name: d[0], y: d[1] });
            } else if (typeof d === 'object') {
              items.push({ name: d.name || series.name, y: d.y || d.data || 0 });
            }
          }
        }
      }
      items.sort((a, b) => b.y - a.y);
      const max = items.length > 0 ? items[0].y : 1;
      return items.map((item, i) => ({
        ...item,
        percent: max > 0 ? Math.round((item.y / max) * 100) : 0,
        barColor: colors[i % colors.length],
      }));
    },
    visibleItems() {
      var limit = this.action === 'topsellersorders' ? 10 : 8;
      return this.showAll ? this.rankedItems : this.rankedItems.slice(0, limit);
    },
  },
  data() {
    return {
      fullPage: false,
      showAll: false,
      myChart: "",
      timeserchtype:this.timeserch,
      fromDate:this.from,
      toDate:this.to,
      sellerdata:this.seller,
      chartOptions: { 
                    chart: {
                        type: 'bar',
                        renderTo: 'container',
                        // height: 650,
                         styledMode: true
                    },
                    credits: {
                        enabled: false
                    },
                    title: {
                        text: null,
                    },
                    subtitle: {
                        text: null
                    },
                    xAxis: {
                        type: 'category',
                        // categories: ['Africa', 'America', 'Asia', 'Europe', 'Oceania'],
                        title: {
                            text: 'Product name',
                        },
                         labels: {
                            overflow: 'justify'
                        }
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Quantity order paid',
                            align: 'high'
                        },
                        labels: {
                            overflow: 'justify'
                        }
                    },
                    tooltip: {
                        valueSuffix: ' quantity'
                    },
                    plotOptions: {
                        series: {
                            stacking: 'normal'
                            },
                        bar: {
                            dataLabels: {
                                enabled: true,
                                color: 'white',
                                align: "right",
                                format: '{y} Quantity paid',
                                inside: false,
                                style: {
                                    fontWeight: 'bold'
                                },
                                verticalAlign: "middle"
                            }
                        }
                    },
                    legend: {
                         enabled: false
                    },
                    series: []
                    
                    // series: [
                    // {
                    //     type: 'bar',
                    //     name: ['ou', 'kl', '635', '203', '2'],
                    //     data: [107, 31, 635, 203, 2]
                    // }]
        }
    };
  },
 watch: {
   'timeserch': function () {
      this.timeserchtype=this.timeserch;
   },
   'seller': function () {
       console.log('seller------',this.seller)
       this.sellerdata=this.seller;
   },
    dataChart: function () {
      // if (this.myChart != null) this.myChart.destroy();
      // this.drawChart(this.dataChart,this.label);
      // this.myChart.render();
      this.drawChart(this.dataChart);
    },
  },
  async mounted(){
    //  await this.drawChart(this.dataChart,this.label);
    //  if (this.myChart) this.myChart.render();
    await this.drawChart(this.dataChart);
    if(this.currentUser && this.currentUser.role && this.currentUser.role.name=='Seller' && this.currentUser.type=='Seller') {
      this.sellerdata=this.currentUser;
      if(this.action == 'topproducts') this.chartOptions.chart.height=720;
    }else{
      if(this.action == 'topproducts') this.chartOptions.chart.height=650;
      else this.chartOptions.chart.height=600;
    }

  },
   methods: {
     ChangeDatetop: function (val) {
         this.$emit("ChangeDatetop", val);
    },
    getUsersDebance: function (name) {
        this.$emit("getUsersDebance", name);
     }, 
    FindRecordsBetweenDate: function (val) {
         this.$emit("FindRecordsBetweenDate", this.action,this.fromDate,this.toDate);
    },
    removedata: function (val) {
        this.$emit("removedata", this.action);
     }, 
    async CheckSellerProducts(seller,action,model){
       this.$emit("CheckSellerProducts", seller,action,model);
    },
    generateData(baseval, count, yrange) {
    var i = 0;
    var series = [];
    while (i < count) {
      var x = baseval;
      var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
      var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;
  
      series.push([x, y, z]);
      baseval += 86400000;
      i++;
    }
    return series;
  },
    drawChart(chartData,label=null) {
      if(this.action == 'topsellersorders'){
        this.chartOptions.xAxis.title.text='Sellers';
        this.chartOptions.yAxis.title.text='Nb orders';
        this.chartOptions.tooltip.valueSuffix=' orders';
        this.chartOptions.plotOptions.bar.dataLabels.format='{y} orders';
      }
      this.chartOptions.series=chartData;
      //  var ctx = document.getElementById(this.id);
      //   this.myChart = new ApexCharts(ctx, {
      //     series: chartData,
      //     chart: {
      //     height: 702,
      //     type: 'bubble',
      //     stacked: true,
      //     toolbar: {
      //       show: false
      //     }
      //   },
      //   dataLabels: {
      //     enabled: false
      //   },
      //   stroke: {
      //     width: 2.5,
      //     curve: 'smooth'
      //   },
      //    legend: {
      //     show: 0,
      //     position: "top",
      //     horizontalAlign: "center",
      //     offsetX: -20,
      //     fontSize: "12px",
      //     markers: {
      //       radius: 50,
      //       width: 10,
      //       height: 10
      //     }
      //   },
      //   markers: {
      //     size: 0
      //   },
      //   tooltip: {
      //     enabled: true,
      //     theme: 'dark',
      //      z: {
      //       title: 'Quantity of sales'
      //     },
      //      y: {
      //       formatter: function(val) {
      //         return 'Total sales: '+val+' '+this.currency
      //       },
      //     }
      //   },
      //   fill: {
      //     type: 'gradient',
      //   },
      //   xaxis: {
      //     labels: {
      //       formatter: function (value, timestamp) {
      //          if(label=='month'){
      //               var months = ["January","February","March","April","May","June","July","August","September","October","November","December",];
      //                 value= months[value - 1];
      //           }
      //           if(label=='day') value= value.toFixed();
      //           if(label=="hour") value= ('0' + value).slice(-2)+":00";
      //            return value // The formatter function overrides format property
      //       }, 
      //     }
      //   },
      //   theme: {
      //     palette: 'palette2'
      //   }
      //   });
    },
   }
};
</script>
<style scoped>
.v6-card {
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  transition: all 0.3s ease;
  position: relative;
}
.v6-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.v6-header {
  padding: 20px 24px 12px;
  border-bottom: 1px solid #f1f5f9;
}
.v6-header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.v6-title {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}
.v6-select {
  appearance: auto;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 14px;
  cursor: pointer;
  outline: none;
}
.v6-select:focus { border-color: #4285f4; }
.v6-filters {
  background: #f8fafc;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 8px;
}
.v6-filter-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.v6-filter-item { flex: 1; min-width: 0; }
.v6-filter-select {
  font-size: 12px !important;
  background: #ffffff;
  border-radius: 8px;
}
.v6-filter-clear {
  width: 32px; height: 32px; min-width: 32px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 8px; border: none;
  background: #fee2e2; color: #ef4444;
  cursor: pointer; transition: all 0.2s;
}
.v6-filter-clear:hover { background: #fecaca; }
.v6-filter-date {
  display: flex; align-items: center; gap: 8px;
  padding: 0 24px 8px;
}
.v6-datepicker { flex: 1; }
.v6-filter-search {
  width: 34px; height: 34px; min-width: 34px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 8px; border: none;
  background: #4285f4; color: #ffffff; cursor: pointer;
}
.v6-filter-search:hover { background: #3367d6; }
.v6-filter-search.noselect { opacity: 0.5; cursor: not-allowed; }
.v6-body {
  padding: 8px 16px 0;
  position: relative;
  min-height: 200px;
}

/* Ranked list */
.v6-ranked-list {
  padding: 4px 0 16px;
}
.v6-rank-item {
  display: flex;
  align-items: center;
  padding: 8px 6px;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}
.v6-rank-item:last-child {
  border-bottom: none;
}
.v6-rank-item:hover {
  background: #f8fafc;
  border-radius: 8px;
}

/* Rank badge */
.v6-rank-badge {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
  margin-right: 10px;
}
.v6-rank-1 {
  background: #fef3c7;
  color: #b45309;
}
.v6-rank-2 {
  background: #e5e7eb;
  color: #4b5563;
}
.v6-rank-3 {
  background: #fed7aa;
  color: #c2410c;
}
.v6-rank-default {
  background: #f1f5f9;
  color: #64748b;
}

/* Rank info */
.v6-rank-info {
  flex: 1;
  min-width: 0;
  margin-right: 12px;
}
.v6-rank-name {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  display: block;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v6-rank-bar-wrap {
  width: 100%;
  height: 4px;
  background: #f1f5f9;
  border-radius: 2px;
  overflow: hidden;
}
.v6-rank-bar {
  height: 100%;
  border-radius: 3px;
  transition: width 0.5s ease;
}

/* Quantity */
.v6-rank-qty {
  text-align: right;
  flex-shrink: 0;
}
.v6-rank-qty-val {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  display: block;
  line-height: 1;
}
.v6-rank-qty-label {
  font-size: 9px;
  color: #94a3b8;
  text-transform: uppercase;
}

/* Show more button */
.v6-show-more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px;
  margin-top: 8px;
  border: 1px dashed #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #4285f4;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}
.v6-show-more:hover {
  background: #eff6ff;
  border-color: #4285f4;
}

/* Empty state */
.v6-empty {
  padding: 40px 0;
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
}

/* Keep old class for compatibility */
.card {
    margin-bottom: 0;
    box-shadow: 0 5px 15px rgba(57,98,254,.02),0 3px 6px rgba(117,108,254,.12);
    border: none;
    background-color: #fff;
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: initial;
    border-radius: .25rem;
    flex: 1 1 auto;
    min-height: 1px;
}
</style>
